/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * Functions to track output positions.
 * This info isn’t used yet but suchs functionality allows line wrapping,
 * and theoretically source maps (though, is there practical use in that?).
 *
 * @param {TrackFields} options_
 */
export function track(options_) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.
  /* c8 ignore next 5 */
  var options = options_ || {};
  var now = options.now || {};
  var lineShift = options.lineShift || 0;
  var line = now.line || 1;
  var column = now.column || 1;
  return {
    move: move,
    current: current,
    shift: shift
  };

  /**
   * Get the current tracked info.
   *
   * @returns {{now: Point, lineShift: number}}
   */
  function current() {
    return {
      now: {
        line: line,
        column: column
      },
      lineShift: lineShift
    };
  }

  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @param {number} value
   */
  function shift(value) {
    lineShift += value;
  }

  /**
   * Move past a string.
   *
   * @param {string} value
   * @returns {string}
   */
  function move() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var chunks = value.split(/\r?\n|\r/g);
    var tail = chunks[chunks.length - 1];
    line += chunks.length - 1;
    column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
    return value;
  }
}